module.exports = __webpack_public_path__ + "static/img/icon76.af44669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon76.png
// module id = /5jo
// module chunks = 0